import { Navigate, Outlet } from "react-router-dom";

const useAuth = () => {
  const token = localStorage.getItem("auth_token");
  console.log('[PrivateRoute] Checking auth - Token exists:', !!token);
  console.log('[PrivateRoute] Token value:', token ? `${token.substring(0, 20)}...` : 'null');

  //return !!token;
  return true;
};

const PrivateRoute = () => {
  const isAuthenticated = useAuth();

  if (isAuthenticated) {
    console.log('[PrivateRoute] Authenticated, rendering protected route');
    return <Outlet />;
  }

  console.log('[PrivateRoute] Not authenticated, redirecting to login');
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;